export function RequestHistoryPageSkeleton() {
  return (
    <div
      className="usage-page request-history-page is-loading usage-page-skeleton"
      aria-busy="true"
    >
      <div className="page-loading-bar" aria-hidden="true" />
      <div className="usage-page-actions">
        <span className="skeleton skeleton-action" />
      </div>
      <div className="usage-filter-card usage-filter-skeleton" id="usageFilterStrip">
        <div className="usage-filter-toolbar">
          <span className="skeleton usage-filter-toggle-skeleton" />
          <div className="usage-filter-chips">
            {[0, 1].map((index) => (
              <span className="skeleton usage-filter-chip-skeleton" key={index} />
            ))}
          </div>
        </div>
      </div>
      <section className="usage-panel usage-history-panel">
        <div className="usage-panel-head">
          <div>
            <span className="skeleton skeleton-line skeleton-heading" />
            <span className="skeleton skeleton-line skeleton-copy" />
          </div>
        </div>
        <div className="usage-history-scroll">
          <table>
            <tbody>
              <UsageHistorySkeletonRows />
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}

export function UsageHistorySkeletonRows({ rows = 7 }: { rows?: number }) {
  const cellClasses = [
    'wide',
    'short',
    'medium',
    'short',
    'short',
    'short',
    'short',
    'short',
    'short',
    'short',
    'short',
  ];
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr className="usage-history-skeleton-row" key={rowIndex} aria-hidden="true">
          {cellClasses.map((cellClass, cellIndex) => (
            <td key={cellIndex}>
              <span className={`skeleton usage-history-cell-skeleton ${cellClass}`} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
